import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['dropdown']
  static values = { href: String, default: String, resetAfterNavigate: Boolean }

  initialize() {
    this.defaultValue = this.element.slim.getSelected()[0]
  }

  itemSelected() {
    const newUrl = this.hrefValue || this.element.value

    // Note: itemSelected() will be called twice when the resetAfterNavigate flag is turned on
    // since we are using the setSelected() method from the Slim Select library
    if (this.resetAfterNavigateValue && this.defaultValue !== this.element.value) {
      this.element.slim.setSelected(this.defaultValue)
    }

    window.location.href = newUrl
  }
}
